<dx-popup #dlgEditSessionDelay [width]="450" [height]="300" [showTitle]="true" title="Edit Session Delays"
    [resizeEnabled]=false [dragEnabled]="true" [showCloseButton]="true" [hideOnOutsideClick]="false">

    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="CancelButtonOptions">
    </dxi-toolbar-item>

    <dxi-toolbar-item widget="dxButton" toolbar="bottom" location="after" [options]="OkButtonOptions">
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'">
        <dx-form [showColonAfterLabel]="false" colCount="2" [formData]="sessionDelay" width="100%"
            (onFieldDataChanged)="onFieldDataChanged($event)">
            <dxi-item itemType="simple" [colSpan]="2" >
                <div>
                    Here you can change the pre and post session delays in minutes.                    
                </div>
            </dxi-item>
            <dxi-item itemType="simple" dataField="preSessionDelay" editorType="dxNumberBox" 
                [editorOptions]="{min:0,max:20,width:'100px', showSpinButtons:true}">
                <dxo-label text="Pre-Session Delay (Mins)"></dxo-label>
            </dxi-item>
            <dxi-item itemType="empty"></dxi-item>
            <dxi-item itemType="simple" dataField="postSessionDelay" editorType="dxNumberBox"
                [editorOptions]="{min:0,max:20,width:'100px', showSpinButtons:true}">
                <dxo-label text="Post-Session Delay (Mins)"></dxo-label>
            </dxi-item>
            <dxi-item itemType="empty"></dxi-item>
        </dx-form>
    </div>
</dx-popup>